<!--登录页面-->
<template>
  <div class="login">
    <!-- <div class="header">
            <div class="container_wrap">
                <div class="logoAndname">
                    <img src="~@/assets/images/login/pic-logo.png" style="width:100%;height:100%">
                </div>
                <div class="headnav">
                    <a href="#" v-for="(item,index) in navArr" :key="index">{{item.name}}</a>
                </div>  
                <div class="headlefticon">
                    <div class="headicon">
                        <div class="loginbtn">登录</div>
                    </div>
                    <div class="headicon">
                        <div class="loginbtn registerbtn">注册</div>
                    </div>
                </div>
            </div>
        </div> -->
    <div class="logincontainer">
      <div class="logincontainerEntureWidth">
        <div class="bgitem"></div>
        <div class="logincontainerItem">
          <el-menu
            :default-active="activeIndex"
            class="elmenu"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="login">{{ $T('登录') }}</el-menu-item>
            <!-- <el-menu-item index="register">{{ $T('注册') }}</el-menu-item> -->
          </el-menu>
          <div class="leftLogin" v-if="activeIndex === 'login'">
            <template v-if="!gobackPasswordFlag">
              <el-form
                label-width="108px"
                :model="loginFormdata"
                ref="ruleForm"
                :rules="loginRules"
              >
                <el-form-item :label="$T('账号')" prop="nameOrPhone">
                  <el-input
                    :placeholder="$T('账号')"
                    v-model="loginFormdata.nameOrPhone"
                    clearable
                    style="width: 240px; height: 40px"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$T('密码')" prop="password">
                  <el-input
                    :placeholder="$T('请输入密码')"
                    v-model="loginFormdata.password"
                    style="width: 240px; height: 40px"
                    show-password
                  ></el-input>
                </el-form-item>
                <div
                  class="loginFont tipsCommon"
                  @click="submitForm('ruleForm')"
                >
                  {{ $T('登录') }}
                </div>
                <div class="forget tipsCommon">
                  <div class="forgetpassword" @click="forgetpasswordClickFun()">
                    <!-- {{ $T('忘记密码') }} -->
                  </div>
                </div>
              </el-form>
            </template>

            <template v-else>
              <el-form
                label-width="108px"
                :model="gobackPasswordData"
                ref="ruleForm3"
                :rules="resetPasswordRules"
              >
                <el-form-item :label="$T('手机号')" prop="upd_phone">
                  <el-input
                    :placeholder="$T('请输入中国大陆手机号')"
                    v-model="gobackPasswordData.upd_phone"
                    clearable
                    style="width: 240px; height: 40px"
                    :disabled="ensureCodeFlag"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$T('验证码')" prop="upd_code">
                  <el-input
                    :placeholder="$T('请输入验证码')"
                    v-model="gobackPasswordData.upd_code"
                    clearable
                    style="width: 111px; height: 34px"
                    class="inputidecode"
                    :disabled="ensureCodeFlag"
                  ></el-input>
                  <el-button
                    @click="getidecodeFun(gobackPasswordData.upd_phone)"
                    :disabled="ensureCodeFlag"
                    >{{ codeButtonText }}</el-button
                  >
                </el-form-item>
                <!-- 验证成功之后的表单 -->
                <template v-if="ensureCodeFlag">
                  <el-form-item :label="$T('密码')" prop="upd_password">
                    <el-input
                      :placeholder="$T('请输入密码')"
                      v-model="gobackPasswordData.upd_password"
                      style="width: 240px; height: 40px"
                      show-password
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$T('重复密码')" prop="upd_password2">
                    <el-input
                      :placeholder="$T('请再次确认密码')"
                      v-model="gobackPasswordData.upd_password2"
                      style="width: 240px; height: 40px"
                      show-password
                    ></el-input>
                  </el-form-item>
                </template>
                <div
                  class="loginFont tipsCommon"
                  @click="submitForm3('ruleForm3')"
                >
                  {{ $T('确定') }}
                </div>
                <div class="forget tipsCommon">
                  <div class="forgetpassword" @click="gobackForLoginFun()">
                    {{ $T('返回登录') }}
                  </div>
                </div>
              </el-form>
            </template>
          </div>
          <div class="rightRegister" v-if="activeIndex === 'register'">
            <el-form
              label-width="108px"
              :model="registFormdata"
              ref="ruleForm2"
              :rules="registerRules"
            >
              <!-- <el-form-item label="类型" prop="type">
                <el-radio-group v-model="registFormdata.is_danwei">
                  <el-radio :label="2">个人</el-radio>
                  <el-radio :label="1">单位</el-radio>
                </el-radio-group>
              </el-form-item> -->
              <el-form-item
                v-if="registFormdata.is_danwei != 1"
                :label="$T('用户名')"
                prop="name"
              >
                <el-input
                  :placeholder="$T('用户名')"
                  v-model="registFormdata.name"
                  clearable
                  style="width: 240px; height: 40px"
                ></el-input>
              </el-form-item>
              <el-form-item v-else :label="$T('单位名')" prop="name2">
                <el-input
                  :placeholder="$T('单位名称')"
                  v-model="registFormdata.name2"
                  clearable
                  style="width: 240px; height: 40px"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$T('密码')" prop="password">
                <el-input
                  :placeholder="$T('请输入密码')"
                  v-model="registFormdata.password"
                  style="width: 240px; height: 40px"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item :label="$T('重复密码')" prop="password2">
                <el-input
                  :placeholder="$T('请再次确认密码')"
                  v-model="registFormdata.password2"
                  style="width: 240px; height: 40px"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item :label="$T('手机号')" prop="phone">
                <el-input
                  :placeholder="$T('请输入中国大陆手机号')"
                  v-model="registFormdata.phone"
                  clearable
                  style="width: 240px; height: 40px"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$T('验证码')" prop="code">
                <el-input
                  :placeholder="$T('请输入验证码')"
                  v-model="registFormdata.code"
                  clearable
                  style="width: 111px; height: 34px"
                  class="inputidecode"
                ></el-input>
                <el-button @click="getidecodeFun(registFormdata.phone)">{{
                  codeButtonText
                }}</el-button>
              </el-form-item>
              <div
                class="loginFont tipsCommon"
                @click="submitForm2('ruleForm2')"
              >
                {{ $T('注册') }}
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      navArr: [
        { name: "首页" },
        // { name: "组织结构" },
        { name: "新闻资讯" },
        { name: "通知公告" },
        { name: "免费课程" },
        { name: "星星展示" },
        { name: "资质查询" },
      ],
      activeIndex: "login",
      inputusername: "", //用户名
      inputpassword: "", //密码
      inputmobilphone: "", //手机号码
      inputIdecode: "", //验证码
      inputpasswordagain: "", //再次输入密码
      codeResendSeconds: 0,
      codeTimerId: null,
      inputdepartment: "",
      loginFormdata: {
        nameOrPhone: "",
        password: "",
      },
      registFormdata: {
        is_danwei: 2,
        phone: "",
        code: "",
        name: "",
        name2: "",
        password2: "",
        password: "",
      },

      gobackPasswordData: {
        upd_phone: "",
        upd_code: "",
        upd_password: "",
        upd_password2: "",
      },
      gobackPasswordFlag: false,
      ensureCodeFlag: false, //忘记密码  验证码正确的标志
    };
  },
  computed: {
    codeButtonText() {
      return this.codeResendSeconds > 0
        ? String(this.codeResendSeconds)
        : this.$T("获取验证码");
    },
    loginRules() {
      const T = this.$T.bind(this);
      return {
        nameOrPhone: [
          { required: true, message: T("请输入用户名/手机"), trigger: "blur" },
        ],
        password: [{ required: true, message: T("请输入密码"), trigger: "blur" }],
      };
    },
    registerRules() {
      const T = this.$T.bind(this);
      return {
        phone: [
          { required: true, message: T("请输入手机号"), trigger: "blur" },
          { min: 11, max: 11, message: T("长度在11个字符"), trigger: "blur" },
        ],
        code: [
          { required: true, message: T("请输入验证码"), trigger: "blur" },
          { min: 4, max: 4, message: T("长度在4个字符"), trigger: "blur" },
        ],
        name: [
          { required: true, message: T("请输入用户名"), trigger: "blur" },
          { min: 3, max: 16, message: T("长度在3-16个字符"), trigger: "blur" },
        ],
        name2: [
          { required: true, message: T("请输入单位名"), trigger: "blur" },
          { min: 3, max: 16, message: T("长度在3-16个字符"), trigger: "blur" },
        ],
        password: [{ required: true, message: T("请输入密码"), trigger: "blur" }],
        password2: [
          { required: true, message: T("请再次输入密码"), trigger: "blur" },
        ],
      };
    },
    resetPasswordRules() {
      const T = this.$T.bind(this);
      return {
        upd_phone: [
          { required: true, message: T("手机不能为空"), trigger: "blur" },
          { min: 11, max: 11, message: T("手机号码必须为11位"), trigger: "blur" },
        ],
        upd_code: [
          { required: true, message: T("请输入验证码"), trigger: "blur" },
          { min: 4, max: 4, message: T("验证码须为4位"), trigger: "blur" },
        ],
        upd_password: [
          { required: true, message: T("请输入重置密码"), trigger: "blur" },
        ],
        upd_password2: [
          { required: true, message: T("请再次输入重置密码"), trigger: "blur" },
        ],
      };
    },
  },
  mounted() {
    document.title = this.$T("登录页标题");
  },
  beforeDestroy() {
    this.clearCodeTimer();
  },
  methods: {
    clearCodeTimer() {
      if (this.codeTimerId) {
        clearInterval(this.codeTimerId);
        this.codeTimerId = null;
      }
      this.codeResendSeconds = 0;
    },
    /** 将接口 failure 回调里的 msg 走语言包（服务端多为中文固定文案） */
    apiErrorMsg(payload) {
      const raw =
        payload &&
        (payload.msg !== undefined && payload.msg !== null && payload.msg !== ""
          ? payload.msg
          : payload.message);
      const s = raw == null ? "" : String(raw).trim();
      if (!s) {
        return this.$T("不好意思出错啦");
      }
      return this.$T(s);
    },
    //忘记密码  点击事件
    forgetpasswordClickFun() {
      this.gobackPasswordFlag = true;
      this.ensureCodeFlag = false;
      this.clearCodeTimer();
      this.resetForm();
    },
    //返回登录点击事件
    gobackForLoginFun() {
      this.gobackPasswordFlag = false;
      this.ensureCodeFlag = false;
      this.clearCodeTimer();
      this.resetForm();
    },
    handleSelect(val) {
      this.activeIndex = val;
      this.clearCodeTimer();
      this.inputusername = "";
      this.inputpassword = "";
      this.inputmobilphone = "";
      this.inputIdecode = "";
      this.inputpasswordagain = "";
      this.inputdepartment = "";
      this.resetForm();
    },
    //登录点击事件
    loginFun() {
      if (
        this.inputusername.trim() == "" ||
        this.inputpassword.trim() == "" ||
        this.inputdepartment.trim() == ""
      ) {
        this.$message({ type: "error", message: this.$T("单位用户名密码不能为空") });
        this.inputusername = "";
        this.inputpassword = "";
        return;
      }
      //发起请求判断密码账号 是否正确
    },
    //注册点击事件
    registerFun() {
      if (this.inputpasswordagain != this.inputpassword) {
        this.$message({ type: "error", message: this.$T("密码确认错误") });
        // this.inputusername="";
        this.inputpassword = "";
        // this.inputdepartment="";
        this.inputpasswordagain = "";
        return;
      }
      if (
        this.inputusername.trim() == "" ||
        this.inputpassword.trim() == "" ||
        this.inputdepartment.trim() == "" ||
        this.inputpasswordagain.trim() == ""
      ) {
        this.$message({ type: "error", message: this.$T("内容不能为空") });
        return;
      }
      //发起请求判断
    },

    submitForm(formName) {
      const that = this;
      console.log("formName");
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.$api.post(
            "/api/index/login",
            that.loginFormdata,
            (r) => {
              that.$message.success(that.$T("登录成功"));
              localStorage.setItem("_token", r.data.token);
              if(this.$route.query.url){
                window.open(decodeURIComponent(this.$route.query.url),'_self')
              }else{
                that.$router.push({ path: "/" });
                location. reload()
              }
              
            },
            (r) => {
              that.$message.error(that.apiErrorMsg(r));
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitForm2(formName) {
      const that = this;
      console.log("formName");
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (that.registFormdata.password != that.registFormdata.password2) {
            that.$message.error(that.$T("两次密码不一致"));
            return false;
          }
          that.$api.post(
            "/api/index/register",
            that.registFormdata,
            (r) => {
              that.$message.success(that.$T("注册成功"));
              localStorage.setItem("_token", r.data.token);
              that.$router.push({ path: "/" });
              location. reload()
            },
            (r) => {
              that.$message.error(that.apiErrorMsg(r));
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    submitForm3(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.ensureCodeFlag) {
            //验证码及手机 未验证
            this.checkPhoneCode(
              this.gobackPasswordData.upd_phone,
              this.gobackPasswordData.upd_code
            );
          } else {
            //已经成功验证
            if (
              this.gobackPasswordData.upd_password !=
              this.gobackPasswordData.upd_password2
            ) {
              this.$message.error(this.$T("两次密码不一致"));
              return false;
            }

            this.$api.post(
              "/api/index/setPasswordByPhone",
              {
                phone: this.gobackPasswordData.upd_phone,
                password: this.gobackPasswordData.upd_password,
              },
              (res) => {
                this.gobackPasswordFlag = false;
                this.gobackPasswordData = {
                  upd_phone: "",
                  upd_code: "",
                  upd_password: "",
                  upd_password2: ""
                };
                this.ensureCodeFlag = false;
                this.clearCodeTimer();
                this.$message.success(this.$T("请登录"));
              },
              (err) => {
                this.$message.error(this.apiErrorMsg(err));
              }
            );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //获取验证码 点击事件
    getidecodeFun(phone) {
      const that = this;
      that.$api.post(
        "/api/index/phonecode",
        {
          phone: phone,
        },
        (r) => {
          this.$message.success(this.$T("发送成功"));
          if (this.codeResendSeconds <= 0) {
            this.clearCodeTimer();
            this.codeResendSeconds = 59;
            this.codeTimerId = setInterval(() => {
              this.codeResendSeconds -= 1;
              if (this.codeResendSeconds <= 0) {
                this.clearCodeTimer();
              }
            }, 1000);
          }
        },
        (r) => {
          that.$message.error(that.apiErrorMsg(r));
        }
      );
    },
    //检查验证码是否输入正确
    checkPhoneCode(phone, code) {
      this.$api.post(
        "/api/index/checkPhoneCode",
        { phone: phone, code: code },
        (res) => {
          this.ensureCodeFlag = true;
          this.$message.success(this.$T("验证通过请重置密码"));
        },
        (err) => {
          this.$message.error(this.apiErrorMsg(err));
        }
      );
    },
    resetForm() {
      var formName = ["ruleForm", "ruleForm2", "ruleForm3"];
      formName.some((item) => {
        if (this.$refs[item]) {
          this.$refs[item].resetFields();
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "./Login.scss";
.elmenu {
  display: flex;
  justify-content: center;
}
// /deep/.el-menu{
//      display:flex;
//      justify-content: center;
// }
/deep/.el-menu-item {
  font-size: 16px;
  display: inline-block;
}
.is-active {
  font-size: 16px;
  color: #000;
  font-weight: bold;
}
.inputidecode {
  .el-input__inner {
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?f8a1775c